import { Component, HostListener, ViewContainerRef, AfterViewInit, OnDestroy, Inject, PLATFORM_ID, ViewEncapsulation, inject } from '@angular/core';
import { AuthService } from '../app/auth.service';
import { UIService } from '../app/ui.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { correctHeight, detectBody } from './app.helpers';

// internacionalization
import { Router, NavigationEnd, ActivationStart, RouterOutlet } from '@angular/router';
import { ViewChild } from '@angular/core';

import { filter } from 'rxjs/operators';
import { HelpService } from './components/common/help/help.service';
import { HeaderActionsService } from './components/common/sub-header/header-actions.service';
import { BaseComponent } from './components/common/baseComponent/base.component';
import { InitService } from '../services/init.service';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { WaitComponent } from './components/common/waitLoading/wait.component';
import { ScreenService } from '../services/screen/screen.service';
import { NavigationUtilsService } from './_core/domain/services/navigation/navigation-utils.service';
import { AuthUseCase } from './_core/application/auth/auth.use-cases';
import { NewVersionComponent } from './_presentation/features/components/modals/new-version/new-version.component';

declare let jQuery: any;

export class ModeViewClass {
  static MODE_VIEW_XS = 'mode_view_xs';
  static MODE_VIEW_SM = 'mode_view_sm';
  static MODE_VIEW_MD = 'mode_view_md';
  static MODE_VIEW_LG = 'mode_view_lg';
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [ToastModule, SharedModule, NgClass, RouterOutlet, WaitComponent, NewVersionComponent]
})
export class AppComponent extends BaseComponent implements AfterViewInit, OnDestroy {
  private readonly _authUseCases = inject(AuthUseCase);

  @ViewChild('checkLg', { read: ViewContainerRef, static: true })
  checkLg: ViewContainerRef;
  @ViewChild('checkMd', { read: ViewContainerRef, static: true })
  checkMd: ViewContainerRef;
  @ViewChild('checkSm', { read: ViewContainerRef, static: true })
  checkSm: ViewContainerRef;
  private modeView: BehaviorSubject<string>;
  public modeViewObservable: Observable<string>;
  public load = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _windowRefService: ScreenService,
    protected initService: InitService,
    private authService: AuthService,
    private navigationUtilsService: NavigationUtilsService,
    private helpService: HelpService,
    private headerService: HeaderActionsService,
    public router: Router,
    public uiService: UIService
  ) {
    super();
    if (isPlatformBrowser(this.platformId)) {
      this._windowRefService.initWindowListeners();
    }
    this.modeView = new BehaviorSubject<string>('');
    this.modeViewObservable = this.modeView.asObservable();
    // limpiar ayuda contextual al navegar a un nuevo componente
    this.subscribe(router.events.pipe(filter((event) => event instanceof ActivationStart)), (event: ActivationStart) => {
      helpService.clearContextHelp();
      headerService.clearSubHeader();
    });

    if (this.authService.isLoggedIn()) {
      this.initService.init();
      this._authUseCases.setAuth({ isLoggedIn: true });
    }
  }

  ngOnDestroy() {
    // elminar funciones jQuery registradas para limpieza de memoria
    jQuery(window).off('load resize');
    jQuery('.metismenu a').off('click');
    this.headerService.clearActions();
    // marcar complete para obligar a unsubscribe de observables
    this.modeView.complete();
    super.ngOnDestroy();
  }

  @HostListener('window:beforeunload', ['$event'])
  logoutOnClose() {
    if (!this.navigationUtilsService.isIgnoreUnloadApp()) {
      if (this.authService.isLoggedIn()) {
        this.authService.logout();
        event.returnValue = false;
        event.preventDefault();
      }
    } else {
      this.navigationUtilsService.setIgnoreUnloadApp(false);
    }
  }

  private resizeHandler(): void {
    correctHeight();
    detectBody();
    this.checkViewSize(this.modeView);
  }

  ngAfterViewInit() {
    // para soporte a sso, comprobar si se ha metido en el sessionstorage el resultado del login
    const ssoResponse = sessionStorage.getItem('login.sso-response');
    if (ssoResponse) {
      this.authService.processSsoLogin(ssoResponse);
      sessionStorage.removeItem('login.sso-response');
    }
    // Run correctHeight function on load and resize window event
    this.checkViewSize(this.modeView);
    detectBody();
    jQuery(window).bind('load resize', this.resizeHandler.bind(this));

    // forzamos reiniciar el scroll en el cambio de vista
    this.subscribe(this.router.events, (evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
    });

    // Correct height of wrapper after metisMenu animation.
    jQuery('.metismenu a').click(() => {
      setTimeout(() => {
        correctHeight();
      }, 300);
    });

    // this.authService.startupTokenRefresh();
  }

  checkViewSize(modeView: BehaviorSubject<string>) {
    let newMode = '';
    if (jQuery('#checkLg').is(':visible')) {
      newMode = ModeViewClass.MODE_VIEW_LG;
    } else if (jQuery('#checkMd').is(':visible')) {
      newMode = ModeViewClass.MODE_VIEW_MD;
    } else if (jQuery('#checkSm').is(':visible')) {
      newMode = ModeViewClass.MODE_VIEW_SM;
    } else {
      newMode = ModeViewClass.MODE_VIEW_XS;
    }
    if (modeView.value != newMode) {
      modeView.next(newMode);
    }
    jQuery('body').toggleClass('modal-open', false);
  }
}
